import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "fryPurchase";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    fryPurchaseList: {
      // 获取基地table列表
      list: [],
      total: 0,
    },
  },
  actions: {
    //周期批次
    async getPondUnclearedBatchNo(a, pondId) {
      let result = await api.get(
        `/api/FishBatch/GetPondUnclearedBatchNo/${pondId}`
      );
      return result.data;
    },
    //添加
    async addFryPurchase(a, payload) {
      let result = await api.post("/api/FishPurchase", payload);
      return result.data;
    },
    //修改
    async updateFryPurchase(a, payload) {
      let result = await api.put(
        `/api/FishPurchase/${payload.id}`,
        payload.data
      );
      return result.data;
    },
    //获取表格所有数据
    async getFryPurchase({ commit }, payload) {
      let result = await api.get(
        `/api/FishPurchase?${queryString.stringify(payload)}`
      );
      // 单位换算
      let fiterList = result.data.list.map((item) => {
        if (item.specType == 14000) {
          item.specType = "斤/尾";
        } else if (item.specType == 14001) {
          item.specType = "尾/斤";
        } else if (item.specType == 14002) {
          item.specType = "万尾";
          item.quantity = item.quantity / 10000;
        }
        return item;
      });
      if (result.status === 200) {
        commit("setFryPurchaseList", result.data);
      }
      return result;
    },
    //删除数据
    async delFryPurchase(a, payload) {
      let result = await api.delete(`/api/FishPurchase/${payload}`);
      return result;
    },
    //删除列表子数据
    async delFryPurchaseDetail(a, payload) {
      let result = await api.delete(`/api/FishPurchase/Detail/${payload}`);
      return result;
    },
    //编辑---获取单行数据
    async getFryPurchaseData(a, payload) {
      let result = await api.get(`/api/FishPurchase/${payload}`);
      let fiterList = result.data.details.map((item) => {
        if (item.specType == 14002) {
          item.quantity = item.quantity / 10000;
        }
        return item;
      });
      return result.data;
    },
  },
  mutations: {
    setFryPurchaseList(state, payload) {
      state.fryPurchaseList = payload;
    },
  },
});

export default moduleName;
